export class AdminDataReportingSignatureTotals {
  maritalStatusSingle: number;
  maritalStatusMarried: number;
  verifiedMultiSigner: number;
  verifiedSingleSigner: number;
  spouseAccountVerified: number;
}
